import { filterServicesCountedInStageTotals } from "./budget-stage-visibility";

// Considera "Fornecedor a Definir" quando o nome contém "A DEFINIR",
// o supplierId é temporário (contém "-") ou não há fornecedor definido.
export function isSupplierToBeDefined(service: {
  supplierName?: string;
  supplierId?: string;
}): boolean {
  const name = (service.supplierName ?? "").toUpperCase();
  const id = service.supplierId ?? "";
  return name.includes("A DEFINIR") || id.includes("-") || id === "";
}

type UndefinedSupplierService = {
  versions?: number[];
  supplierName?: string;
  supplierId?: string;
  type?: string;
  calcOption?: string;
  budgetValues?: { calcOption?: string };
  negotiationValue?: Array<{ calcOption?: string } | undefined>;
  closingValues?: { calcOption?: string };
};

type UndefinedSupplierBudget = {
  budgetServices?: UndefinedSupplierService[];
  supplierList?: {
    supplierId?: string;
    calcOption?: string;
    deletedInVersions?: number[];
  }[];
  addedItemTypeList?: {
    type?: string;
    supplierId?: string;
    calcOption?: string;
    deletedInVersions?: number[];
  }[];
};

// Conta os itens "a definir" que aparecem na etapa exibida
// (version 0 = Orçamento; version > 0 = Negociação/Fechamento).
//
// MMV-2667: conta só o que o editor desenha — o mesmo filtro da sidebar e dos
// totais da etapa. Serviço órfão (sem card em `supplierList`, ou com a
// categoria/fornecedor excluídos na etapa) é invisível e o usuário não tem como
// trocar o fornecedor dele; contá-lo travava o Pré Fechamento sem saída.
export function countUndefinedSuppliers(
  budget: UndefinedSupplierBudget,
  version: number,
  status?: string,
): number {
  return filterServicesCountedInStageTotals(
    budget.budgetServices,
    version,
    status,
    budget.supplierList ?? [],
    budget.addedItemTypeList,
  ).filter(isSupplierToBeDefined).length;
}
